export const FEATURES = {
  SENDGRID_NOTIFICATION_PREFERENCES: 'sendgrid_notification_preferences',
  PHONE_NUMBER_TYPES: 'phone_number_types',
  LOCKED_PRISMIC_CONTENT: 'locked_prismic_content',
  PUPPY_COLLEGE: 'puppy_college',
  PUPPY_COLLEGE_APP: 'puppy_college_app',
  HASH_QUERY_PARAMS: 'hash_query_params',
  PLAID_SETUP: 'plaid_setup',
  SEO_LANDING_PAGE: 'seo_landing_page',
  RUDDERSTACK_TRACKING: 'rudderstack_tracking',
  STATE_PAGE_UPDATES: 'state_page_updates'
};
